import Vue from 'vue';
import Router from 'vue-router';
import Home from './components/HomeComponent.vue';
import Example from './components/ExampleComponent.vue';

Vue.use(Router);

export default new Router({
  mode: 'history', // ładne URL bez #
  base: '/',
  routes: [
    { path: '/', name: 'home', component: Home },
    { path: '/example', name: 'example', component: Example }
  ]
});